import type { CreateOfferCargoFormSchemaType } from "@/pages/admin-cargo-create/model/validation";
import { BaseAccordion } from "@/shared/ui/base-accordion";
import { BaseAccordionSummary } from "@/shared/ui/base-accordion-summary";
import { BaseFormLabel } from "@/shared/ui/base-form-label";
import { BaseTextField } from "@/shared/ui/base-text-field";
import { AccordionDetails, Stack } from "@mui/material";
import { type Control, Controller } from "react-hook-form";

export const MemoForm = ({
  control,
}: {
  control: Control<CreateOfferCargoFormSchemaType>;
}) => {
  return (
    <BaseAccordion defaultExpanded>
      <BaseAccordionSummary>その他・特記事項</BaseAccordionSummary>
      <AccordionDetails>
        <Stack spacing={3}>
          <BaseFormLabel label="その他・特記事項" sx={{ maxWidth: "376px" }}>
            <Controller
              name="memo"
              control={control}
              render={({ field, fieldState }) => (
                <BaseTextField
                  {...field}
                  multiline
                  fullWidth
                  rows={4}
                  variant="outlined"
                  error={fieldState.invalid}
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </BaseFormLabel>
        </Stack>
      </AccordionDetails>
    </BaseAccordion>
  );
};
